function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { FunnelPlotFilled, MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons';
import { Button, Empty, Tooltip, Tree } from 'antd';
import classnames from 'classnames';
import { useEffect, useRef, useState } from 'react';
import styles from "./index.module.css";
import { nanoid } from 'nanoid';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var TreeSelect = function TreeSelect(props) {
  var dataSource = props.dataSource,
    value = props.value,
    onExpandChange = props.onExpandChange,
    numberMap = props.numberMap,
    hasStore = props.hasStore;
  useEffect(function () {
    setOpen(false);
    setChecked([]);
    setHalfChecked([]);
    setSource(buildSource(dataSource, dataRef.current.checked, dataRef.current.halfChecked) || dataSource);
    setRenderKey(nanoid());
  }, [dataSource]);
  useEffect(function () {
    var js2 = localStorage.getItem('ORDER_APPLY_DATA_REF');
    var d2;
    if (js2) {
      try {
        d2 = JSON.parse(js2);
        dataRef.current = d2 || {
          checked: [],
          halfChecked: []
        };
      } catch (error) {
        setSource(dataSource);
        console.log(error);
      }
    } else {
      setSource(dataSource);
    }
  }, []);
  useEffect(function () {
    setSelectedKeys(value ? [value] : []);
  }, [value]);

  /** 主数据相关 */
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    expanded = _useState2[0],
    setExpanded = _useState2[1]; // 是否展开
  var _useState3 = useState(dataSource),
    _useState4 = _slicedToArray(_useState3, 2),
    source = _useState4[0],
    setSource = _useState4[1]; // 选中的数据
  var dataRef = useRef({
    checked: [],
    halfChecked: []
  });

  /** 弹窗相关 */
  var _useState5 = useState(nanoid()),
    _useState6 = _slicedToArray(_useState5, 2),
    renderKey = _useState6[0],
    setRenderKey = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    open = _useState8[0],
    setOpen = _useState8[1];
  var _useState9 = useState([]),
    _useState10 = _slicedToArray(_useState9, 2),
    checked = _useState10[0],
    setChecked = _useState10[1];
  var _useState11 = useState([]),
    _useState12 = _slicedToArray(_useState11, 2),
    halfChecked = _useState12[0],
    setHalfChecked = _useState12[1];
  var _useState13 = useState([]),
    _useState14 = _slicedToArray(_useState13, 2),
    selectedKeys = _useState14[0],
    setSelectedKeys = _useState14[1];
  var selectedData = dataRef.current.checked.length > 0;
  var showSelectModal = function showSelectModal() {
    setChecked(dataRef.current.checked);
    setHalfChecked(dataRef.current.halfChecked);
    setOpen(true);
  };
  var onCheck = function onCheck(checkedKeys, _ref) {
    var halfCheckedKeys = _ref.halfCheckedKeys;
    setChecked(checkedKeys);
    setHalfChecked(halfCheckedKeys);
  };
  var reset = function reset() {
    setChecked(dataRef.current.checked);
    setHalfChecked(dataRef.current.halfChecked);
  };
  var onSure = function onSure() {
    var s = buildSource(dataSource, checked, halfChecked);
    dataRef.current = {
      checked: checked,
      halfChecked: halfChecked
    };
    setSource(s);
    setChecked([]);
    setHalfChecked([]);
    setOpen(false);
    localStorage.setItem('ORDER_APPLY_DATA_REF', JSON.stringify(dataRef.current));
  };
  var buildSource = function buildSource(ds, cd, hd) {
    var map = [];
    if (cd.length === 0) {
      return ds;
    }
    ds.forEach(function (d) {
      if (cd.includes(d.key)) {
        map.push(d);
      } else if (hd.includes(d.key)) {
        var cloned = _objectSpread({}, d);
        cloned.children = buildSource(cloned.children, cd, hd);
        map.push(cloned);
      }
    });
    return map.length > 0 ? map : undefined;
  };
  var onSelect = function onSelect() {
    var keys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    setSelectedKeys(keys);
    props.onChange && props.onChange(keys[0]);
  };
  return /*#__PURE__*/_jsxs("div", {
    className: classnames(styles.container, expanded ? null : styles.expanded),
    children: [/*#__PURE__*/_jsxs("div", {
      className: styles.header,
      children: [expanded ? /*#__PURE__*/_jsx(Tooltip, {
        open: open,
        overlayStyle: {
          maxWidth: 330
        },
        destroyTooltipOnHide: true,
        trigger: "click",
        onOpenChange: function onOpenChange() {
          return setOpen(function (v) {
            return !v;
          });
        },
        title: function title() {
          return /*#__PURE__*/_jsxs("div", {
            className: styles.tooltip,
            children: [/*#__PURE__*/_jsx("div", {
              className: styles.tooltipTree,
              children: /*#__PURE__*/_jsx(Tree, {
                treeData: dataSource,
                checkable: true,
                checkedKeys: {
                  checked: checked,
                  halfChecked: halfChecked
                },
                onCheck: onCheck,
                defaultExpandAll: true,
                selectable: false
              })
            }), /*#__PURE__*/_jsxs("div", {
              className: styles.btnContainer,
              children: [/*#__PURE__*/_jsx(Button, {
                onClick: reset,
                size: "middle",
                children: "\u91CD\u7F6E"
              }), /*#__PURE__*/_jsx(Button, {
                type: "primary",
                onClick: onSure,
                size: "middle",
                children: "\u786E\u5B9A"
              })]
            })]
          });
        },
        color: "white",
        placement: "bottomLeft",
        children: /*#__PURE__*/_jsxs("div", {
          className: styles.filterFlex,
          onClick: showSelectModal,
          children: [/*#__PURE__*/_jsx(FunnelPlotFilled, {
            className: classnames(styles.icon, selectedData ? styles.blueColor : null)
          }), /*#__PURE__*/_jsx("div", {
            className: classnames(styles.headerText, selectedData ? styles.blueColor : null),
            children: selectedData ? '已选择以下分类' : '全部分类'
          })]
        })
      }) : null, /*#__PURE__*/_jsxs("div", {
        className: styles.inlineFlex,
        onClick: function onClick() {
          setExpanded(function (v) {
            return !v;
          });
          onExpandChange === null || onExpandChange === void 0 || onExpandChange(!expanded);
        },
        children: [expanded ? /*#__PURE__*/_jsx(MenuFoldOutlined, {
          className: styles.icon
        }) : /*#__PURE__*/_jsx(MenuUnfoldOutlined, {
          className: styles.icon
        }), /*#__PURE__*/_jsx("div", {
          children: expanded ? '收起' : '展开'
        })]
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: styles.content,
      children: expanded ? hasStore ? /*#__PURE__*/_jsx(Tree, {
        blockNode: true,
        treeData: source,
        defaultExpandAll: true,
        onSelect: onSelect,
        titleRender: function titleRender(node) {
          return /*#__PURE__*/_jsxs("div", {
            className: styles.titleRender,
            style: {
              width: node.isLeaf ? 170 : undefined
            },
            children: [/*#__PURE__*/_jsx(Tooltip, {
              title: node.title,
              children: /*#__PURE__*/_jsx("div", {
                className: node.isLeaf ? styles.titleRenderLeafText : styles.titleRenderText,
                children: node.title
              })
            }), numberMap && numberMap[node.key] ? /*#__PURE__*/_jsxs("div", {
              className: styles.titleRenderRed,
              children: [numberMap[node.key].numerator, "/", numberMap[node.key].denominator]
            }) : null]
          });
        },
        selectedKeys: selectedKeys
      }, renderKey) : /*#__PURE__*/_jsx(Empty, {
        className: styles.empty,
        image: Empty.PRESENTED_IMAGE_SIMPLE,
        description: '请先选择门店'
      }) : null
    })]
  });
};
export default TreeSelect;